import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "./images/logo.svg";
import styles from "./css/landPage.module.scss";
import landIcon from "./images/landIcon.png";
import groupBox from "./images/groupBox.png";
import group2 from "./images/group2.png";
import landDownBtn from "./images/landDownBtn.png";
import landDown from "./images/landDown.png";
import leftImg from "./images/leftImg.png";
import rightImg from "./images/rightImg.png";
import FooterLp from "./FooterLp.jsx";

const yaml = require("js-yaml");

const baseUrl = "https://tool.yunqiboyuan.com/";
const timestamp = new Date().getTime();
const ymlUrl = `${baseUrl}upload/appversion/latest.yml?v=${timestamp}`;
const getyqvidUrl = `${baseUrl}/wapapi/operation/getyqvid`;
const downPostUrl = `${baseUrl}/wapapi/operation/record`;
var yqvid = '';
const NewLandPage = () => {
  const navigate = useNavigate();
  const handleNavigate = (path) => {
    navigate(path);
  };

  const [app_name, setApp_name] = useState("");
  const [downloadUrl, setDownloadUrl] = useState("");

  useEffect(() => {
    fetchAndParseYaml(ymlUrl);
  }, []);

  async function fetchAndParseYaml(url) {
    console.log("url-----------------------", url);
    try {
      // 发送 HTTP GET 请求获取 YAML 文件内容
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = await response.text();
      // 解析 YAML 内容
      const config = yaml.load(data);
      // 读取并打印 path 字段
      const filePath = config?.path;
      console.log("Path:", filePath);
      setDownloadUrl(`${baseUrl}upload/appversion/${filePath}`);
      setApp_name(filePath);
    } catch (e) {
      console.error("读取或解析 YAML 文件时出错:", e);
    }
  }

  const getStr4 = () => {
      return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  }
  const getUuid = () => {
      return (getStr4()+getStr4()+getStr4()+getStr4()+getStr4()+getStr4()+getStr4()+getStr4());
  }

  async function getyqvid () {
    const locationHref = new URL(window.location.href);
    const bdvid = locationHref.searchParams.get("bd_vid");
    if(!bdvid) {return}
    const response = await fetch(getyqvidUrl, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "bdvid": bdvid,
        "logidurl": locationHref.href,
      }),
    });
    const data = await response.text();
    // 解析 YAML 内容
    const config = yaml.load(data);
    yqvid = config.data.yqvid;
  }
  getyqvid();

  const download = async () => {
    const downurl = '/upload/yunqi-zip-decompression-1.1.14_OFFICIAL-114.exe'
    const a = document.createElement("a");
    a.href = downurl;
    a.download = 'yunqi-zip-decompression_YQTG-' + yqvid + '.exe';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    try {
      // 发送 HTTP GET 请求获取 YAML 文件内容
      const response = fetch(downPostUrl, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          "t": 1,
          "p": 1,
          "op": "download",
          "sc": 1,
          "ot": 0,
          "v": "YQTG",
          "sv": "",
          "oc": timestamp,
          "cn": "YQTG",
          "uuid": getUuid(),
          "yqvid": yqvid
        })
      });
      
    } catch (e) {
      console.error("读取或解析 YAML 文件时出错:", e);
    }
  };
  const hostUrl = window.location.href;
  let title = "云启zip解压缩工具"
  if (hostUrl.includes('pdf')){
    title = '云启PDF解压缩工具'
  }
  if (hostUrl.includes('image')){
    title = '云启图片解压缩工具'
  }

  if (hostUrl.includes('video')){
    title = '云启视频解压缩工具'
  }
  

  return (
    <>
      <header className={styles.header}>
        {/* <div className={styles.logo}>
          <img src={logo} title="logo" />
        </div> */}
{/* 
        <div className={styles.nav}>
          <span style={{ color: "#ff4338" ,marginRight:'45px'}} onClick={() => handleNavigate("/")}>首页</span>
          <span style={{ marginRight:'45px'}} onClick={() => handleNavigate("/helper")}>使用帮助</span>
          <span onClick={() => handleNavigate("/about")}>关于我们</span>
        </div> */}
      </header>
      <main className={styles.newMain}>
        <div className={styles.backColor}></div>
        <div className={styles.landMain}>
            <div className={styles.text1}>
                <img src={landIcon}/>
                <span>云启zip解压缩工具</span>
                <div className={styles.text1Icon}>官方</div>
            </div>
            <div className={styles.text2}>一款正版快速解压、压缩文件的轻便文件管理工具!</div>
            <div className={styles.wrapper}>
                <div className={styles.wrapperLeft}>
                    <img src={groupBox} alt="" />
                    <div className={styles.box1} onClick={() => download()}></div>
                    <div className={styles.box2} onClick={() => download()}></div>
                    <div className={styles.box3} onClick={() => download()}></div>
                    <div className={styles.box4} onClick={() => download()}></div>
                </div>
                <div className={styles.wrapperRight}>
                    <img className={styles.landDownBtn} src={landDownBtn} onClick={() => download()} alt="" />
                    <img className={styles.group2} src={group2} alt="" />
                </div>
            </div>
            <div className={styles.towBox}>
                <img className={styles.leftImg} src={leftImg} alt="" />
                <img className={styles.rightImg} src={rightImg} alt="" />
            </div>
            <div className={styles.landDown} alt="" >
                <img src={landDown} onClick={() => download()} alt="" />
            </div>
        </div>
      </main>
      <FooterLp />
    </>
  );
};

export default NewLandPage;
